// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#main {
  display: flex;
  justify-content: center;
}
#main .body-container {
  width: 82rem;
}
#main .body-container .container {
  min-height: 790px;
}
@media print {
  #main .body-container {
    width: 100%;
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.ep-error-container {
  top: 4.5rem;
  right: 1.5rem;
  left: auto;
  bottom: auto;
  transform: none;
  padding: 0;
  position: fixed;
  z-index: 9999;
  min-width: 20rem;
  max-width: 42rem;
  width: max-content;
}
.ep-error-container__error {
  animation-name: fadeOut;
  animation-duration: 10s;
  background-color: var(--ods-color-white);
  border-left: 4px solid var(--ods-color-purple-60);
  border-top: 1px solid var(--ods-color-gray-20);
  border-right: 1px solid var(--ods-color-gray-20);
  border-bottom: 1px solid var(--ods-color-gray-20);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  color: var(--ods-color-gray-80);
  font-size: 0.875rem;
  font-weight: 500;
  list-style-type: none;
  margin-bottom: 0.5rem;
  padding: 0.875rem 1.25rem;
  position: relative;
  border-radius: 0 0.375rem 0.375rem 0;
}`, "",{"version":3,"sources":["webpack://./src/app/main/main.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;AACF;AACE;EACE,YAAA;AACJ;AAAI;EACE,iBAAA;AAEN;AACE;EACE;IACE,WAAA;EACJ;AACF;;AAGA;EACE;IACE,UAAA;EAAF;EAEA;IACE,UAAA;EAAF;EAEA;IACE,UAAA;EAAF;AACF;AAGA;EACE,WAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AADF;AAGE;EACE,uBAAA;EACA,uBAAA;EACA,wCAAA;EACA,iDAAA;EACA,8CAAA;EACA,gDAAA;EACA,iDAAA;EACA,0CAAA;EACA,+BAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oCAAA;AADJ","sourcesContent":["#main {\n  display: flex;\n  justify-content: center;\n\n  .body-container {\n    width: 82rem;\n    .container {\n      min-height: 790px;\n    }\n  }\n  @media print {\n    .body-container {\n      width: 100%;\n    }\n  }\n}\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  90% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n.ep-error-container {\n  top: 4.5rem;\n  right: 1.5rem;\n  left: auto;\n  bottom: auto;\n  transform: none;\n  padding: 0;\n  position: fixed;\n  z-index: 9999;\n  min-width: 20rem;\n  max-width: 42rem;\n  width: max-content;\n\n  &__error {\n    animation-name: fadeOut;\n    animation-duration: 10s;\n    background-color: var(--ods-color-white);\n    border-left: 4px solid var(--ods-color-purple-60);\n    border-top: 1px solid var(--ods-color-gray-20);\n    border-right: 1px solid var(--ods-color-gray-20);\n    border-bottom: 1px solid var(--ods-color-gray-20);\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n    color: var(--ods-color-gray-80);\n    font-size: 0.875rem;\n    font-weight: 500;\n    list-style-type: none;\n    margin-bottom: 0.5rem;\n    padding: 0.875rem 1.25rem;\n    position: relative;\n    border-radius: 0 0.375rem 0.375rem 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
